import React from "react";
import { format } from "date-fns";

import { Chip } from "@mui/material";

import DataTable from "../../../common/DataTable";
import ColumnHeader from "../../../common/ColumnHeader";

import { getChipColor } from "../../../../constants/value";

const SelectelSimInfoList = ({
  data,
  meta,
  client,
  loading,
  handleSort,
  disableRowClick,
  handlePageChange,
  handleColumnClick,
  handleFilterChange,
  handlePageSizeChange,
  ...props
}) => {
  const columns = [
    { field: "id", headerName: "ID", flex: 1, sortable: false },
    {
      field: "iccid",
      headerName: "ICCID",
      minWidth: 200,
      flex: 3,
      sortable: false,
      renderHeader: (params) =>
        client ? (
          <ColumnHeader
            label={"ICCID"}
            handleClick={() => handleColumnClick("iccid")}
          />
        ) : (
          "ICCID"
        ),
    },
    {
      field: "msisdn",
      headerName: "MSISDN",
      minWidth: 200,
      flex: 3,
      sortable: false,
      renderHeader: (params) =>
        client ? (
          <ColumnHeader
            label={"MSISDN"}
            handleClick={() => handleColumnClick("msisdn")}
          />
        ) : (
          "MSISDN"
        ),
    },
    {
      field: "imei",
      headerName: "IMEI",
      minWidth: 200,
      flex: 3,
      sortable: false,
      renderHeader: (params) =>
        client ? (
          <ColumnHeader
            label={"IMEI"}
            handleClick={() => handleColumnClick("extra_data.imei")}
          />
        ) : (
          "IMEI"
        ),

      valueGetter: (params) => params.row?.extra_data?.imei || "-",
    },
    {
      field: "status",
      headerName: "Status",
      minWidth: 100,
      flex: 2,
      renderCell: (params) => (
        <Chip
          label={params.row.status}
          size="small"
          color={getChipColor(params.row.status)}
        />
      ),
      sortable: false,
      renderHeader: (params) =>
        client ? (
          <ColumnHeader
            label={"Status"}
            handleClick={() => handleColumnClick("status")}
          />
        ) : (
          "Status"
        ),
    },
    {
      field: "plan",
      headerName: "Plan",
      minWidth: 200,
      flex: 2,
      sortable: false,
      renderHeader: (params) =>
        client ? (
          <ColumnHeader
            label={"Plan"}
            handleClick={() => handleColumnClick("plan")}
          />
        ) : (
          "Plan"
        ),
    },
    {
      field: "data_usage",
      headerName: "Data Usage [MB]",
      filterable: false,
      sortable: false,
      valueGetter: (params) => params.row?.extra_data?.data_usage || "-",
      renderHeader: (params) =>
        client ? (
          <ColumnHeader
            label={"Data Usage [MB]"}
            handleClick={() => handleColumnClick("extra_data.data_usage")}
          />
        ) : (
          "Data Usage [MB]"
        ),
    },
    {
      field: "voice_usage",
      headerName: "Voice Usage",
      filterable: false,
      sortable: false,
      valueGetter: (params) => params.row?.extra_data?.voice_usage || "-",
      renderHeader: (params) =>
        client ? (
          <ColumnHeader
            label={"Voice Usage"}
            handleClick={() => handleColumnClick("extra_data.voice_usage")}
          />
        ) : (
          "Voice Usage"
        ),
    },
    {
      field: "text_usage",
      headerName: "Text Usage",
      filterable: false,
      sortable: false,
      valueGetter: (params) => params.row?.extra_data?.text_usage || "-",
      renderHeader: (params) =>
        client ? (
          <ColumnHeader
            label={"Text Usage"}
            handleClick={() => handleColumnClick("extra_data.text_usage")}
          />
        ) : (
          "Text Usage"
        ),
    },
    {
      field: "exp_date",
      headerName: "Plan Expiry Date",
      minWidth: 75,
      filterable: false,
      flex: 3,
      sortable: false,
      valueGetter: (params) => params.row?.extra_data?.exp_date || "-",
    },
    {
      field: "created_at",
      headerName: "Created At",
      minWidth: 200,
      filterable: false,
      flex: 3,
      sortable: false,
      valueGetter: (params) =>
        params.row.created_at &&
        `${format(new Date(params.row.created_at), "MMMM d, y hh:mm a")}`,
    },
    {
      field: "last_updated",
      headerName: "Last Updated",
      minWidth: 200,
      filterable: false,
      flex: 3,
      sortable: false,
      valueGetter: (params) =>
        params.row.last_updated &&
        `${format(new Date(params.row.last_updated), "MMMM d, y hh:mm a")}`,
    },
  ];

  return (
    <DataTable
      disableColumnFilter
      loading={loading}
      data={data}
      client={client}
      columns={
        client ? columns.map((val) => ({ ...val, sortable: true })) : columns
      }
      metaData={meta}
      handleRowClick={null}
      handlePageChange={handlePageChange}
      handlePageSizeChange={handlePageSizeChange}
      {...props}
    />
  );
};

export default SelectelSimInfoList;
